import React, { Suspense, lazy } from "react";
import "tailwindcss/tailwind.css";

const Hero = lazy(() => import("./sections/Hero"));
const RedPlusAI = lazy(() => import("./sections/RedPlusAI"));
const EasyMeAI = lazy(() => import("./sections/EasyMeAI"));
const MediZoneAI = lazy(() => import("./sections/MediZoneAI"));
const Partner = lazy(() => import("./sections/Partner"));
const StaticLinksSection = lazy(() => import("./sections/StaticLinksSection"));

function App() {
  return (
    <div className="w-full h-full bg-gray-50 text-gray-900">
      <Suspense fallback={<div className="text-center py-20">Loading...</div>}>
        <Hero />
        <RedPlusAI />
        <EasyMeAI />
        <MediZoneAI />
        <Partner />
	<StaticLinksSection />

        <footer className="bg-gray-900 text-white py-8 text-center">
          <p className="text-sm">© 2025 KothariAI. All rights reserved.</p>
        </footer>
      </Suspense>
    </div>
  );
}

export default App;
